import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import Carousel from "./Carousel";
import houses from "./assets/houses.png";
import Wix from "./assets/wix-logo.png";
import WordPress from "./assets/wordpress-logo.png";
import Squarespace from "./assets/squarespace-logo.png";
import Hostinger from "./assets/hostinger-logo.png";

const Mortgage = () => {
  return (
    <div className="page-wrapper">
      <Helmet>
        <meta
          name="description"
          content="SEO for Mortgage Brokers. Improve your search rankings and attract more clients."
        />
        <title>SEO For Mortgage Brokers | Attoli</title>
        <link
          rel="canonical"
          href="https://attoli.com/services/mortgage-brokers"
        />
      </Helmet>

      <div className="servicePage-container">
        <section className="servicePage-section">
          <div className="servicePage-content">
            <div className="servicePage-left">
              <h1 className="servicePage-title">
                SEO For
                <span className="hero-accent"> Mortgage Brokers </span>
              </h1>
              <p className="servicePage-description">
                If you are searching for ways to be found more easily online,
                look no further than attoli who can help you find real leads so
                you don’t have to guess. Let us provide you with mortgage broker
                SEO or mortgage SEO solutions that will convert calls to
                qualified clients through Google search results.
              </p>
              <p className="servicePage-carousel-text">
                Website builders we are familiar with
              </p>
              <div className="servicePage-carousel">
                <Carousel
                  logos={[
                    { src: Wix, alt: "Wix logo" },
                    { src: WordPress, alt: "WordPress logo" },
                    { src: Squarespace, alt: "Squarespace logo" },
                    { src: Hostinger, alt: "Hostinger logo" },
                  ]}
                />
              </div>
              <ul className="servicePage-benefits">
                <li>
                  Keyword research built to compare mortgage rates, lenders, and
                  local brokers
                </li>
                <li>Content that answers real client questions</li>
                <li>
                  Technical fixes that clean up slow pages and poor mobile
                  performance
                </li>
                <li>
                  Local optimization to assist in getting your mortgage broker
                  listed higher on Google Maps
                </li>
                <li>Monthly reports that are clear and comprehensive</li>
              </ul>
            </div>

            <div className="servicePage-right">
              <img
                src={houses}
                alt="three houses in a row with a three purple stripes background"
                className="servicePage-image"
              />
              <Link
                to="https://calendly.com/attoli/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-link"
              >
                <button className="button hero-GST-btn">
                  <span className="GST-text">Get Started Today</span>
                  <span className="svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="20"
                      viewBox="0 0 38 15"
                      fill="none"
                    >
                      <path
                        fill="white"
                        d="M10 7.519l-.939-.344h0l.939.344zm14.386-1.205l-.981-.192.981.192zm1.276 5.509l.537.843.148-.094.107-.139-.792-.611zm4.819-4.304l-.385-.923h0l.385.923zm7.227.707a1 1 0 0 0 0-1.414L31.343.448a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364zM1 7.519l.554.833.029-.019.094-.061.361-.23 1.277-.77c1.054-.609 2.397-1.32 3.629-1.787.617-.234 1.17-.392 1.623-.455.477-.066.707-.008.788.034.025.013.031.021.039.034a.56.56 0 0 1 .058.235c.029.327-.047.906-.39 1.842l1.878.689c.383-1.044.571-1.949.505-2.705-.072-.815-.45-1.493-1.16-1.865-.627-.329-1.358-.332-1.993-.244-.659.092-1.367.305-2.056.566-1.381.523-2.833 1.297-3.921 1.925l-1.341.808-.385.245-.104.068-.028.018c-.011.007-.011.007.543.84zm8.061-.344c-.198.54-.328 1.038-.36 1.484-.032.441.024.94.325 1.364.319.45.786.64 1.21.697.403.054.824-.001 1.21-.09.775-.179 1.694-.566 2.633-1.014l3.023-1.554c2.115-1.122 4.107-2.168 5.476-2.524.329-.086.573-.117.742-.115s.195.038.161.014c-.15-.105.085-.139-.076.685l1.963.384c.192-.98.152-2.083-.74-2.707-.405-.283-.868-.37-1.28-.376s-.849.069-1.274.179c-1.65.43-3.888 1.621-5.909 2.693l-2.948 1.517c-.92.439-1.673.743-2.221.87-.276.064-.429.065-.492.057-.043-.006.066.003.155.127.07.099.024.131.038-.063.014-.187.078-.49.243-.94l-1.878-.689zm14.343-1.053c-.361 1.844-.474 3.185-.413 4.161.059.95.294 1.72.811 2.215.567.544 1.242.546 1.664.459a2.34 2.34 0 0 0 .502-.167l.15-.076.049-.028.018-.011c.013-.008.013-.008-.524-.852l-.536-.844.019-.012c-.038.018-.064.027-.084.032-.037.008.053-.013.125.056.021.02-.151-.135-.198-.895-.046-.734.034-1.887.38-3.652l-1.963-.384zm2.257 5.701l.791.611.024-.031.08-.101.311-.377 1.093-1.213c.922-.954 2.005-1.894 2.904-2.27l-.771-1.846c-1.31.547-2.637 1.758-3.572 2.725l-1.184 1.314-.341.414-.093.117-.025.032c-.01.013-.01.013.781.624zm5.204-3.381c.989-.413 1.791-.42 2.697-.307.871.108 2.083.385 3.437.385v-2c-1.197 0-2.041-.226-3.19-.369-1.114-.139-2.297-.146-3.715.447l.771 1.846z"
                      ></path>
                    </svg>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </section>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-header">
            <h3 className="footer-logo">attoli</h3>
            <p className="footer-quote">
              "I don't know if you knew this Steve, I'm...I'm pretty cool to I
              have a leather jacket of my own" - Dr Steve Brule
            </p>
            <p className="footer-description">
              Attoli is an Ottawa-based SEO company helping finance businesses
              across Canada create visibility, connect with customers, and grow
              online with proven digital marketing and SEO engine optimization
              strategies.
            </p>
          </div>

          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">
              Privacy & Policy
            </Link>
            <Link to="/contact" className="footer-link">
              Contact
            </Link>

            <a
              href="https://calendly.com/attoli/30min"
              target="_blank"
              className="footer-link"
              rel="noreferrer"
            >
              Book a Meeting
            </a>
          </div>

          <div className="footer-copyright">
            © 2025 Attoli. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Mortgage;
